import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import { debounce, get } from 'lodash';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Redirect } from "react-router-dom";

import {
  dispatchRestMaker,
  clearCartLocalStorage,
} from 'helpers/utils';
import {
  UnauthorizedHeader,
  injectIntl,
  SearchComponent,
  Avatar,
  SidebarItems,
} from 'components';
import qs from 'qs';
import sellersActions from 'redux/sellers/actions';
import Sidebar from 'components/App/Sidebar';
import { withTracker } from 'components/Tracker';
import immutableToJS from 'helpers/immutableToJS';
import { getPublicInfo } from 'redux/marketPlace/actions';
import { shopActions } from 'redux/shop/actions';
import { selectState } from 'redux/selectors';

import Shop from './Shop';
import { accessTokenSelector } from 'redux/auth/selectors';

const styles = () => ({
  bio: { maxHeight: '50px', scrollY: 'auto' },
});

class PublicShop extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isConsumer: PropTypes.bool,
    currentMember: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
  };

  static propTypes = {
	accessToken: PropTypes.string,
    history: PropTypes.shape({}),
    permissions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
    })),
    location: PropTypes.shape({}).isRequired,
    publicInfo: PropTypes.shape({}).isRequired,
    publicInfoRequesting: PropTypes.bool,
    createSeller: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    getPublicInfo: PropTypes.func.isRequired,
    readShop: PropTypes.func.isRequired,
    shop: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    accessToken: null,
    publicInfoRequesting: false,
    history: {},
    permissions: [],
  };

  state = {
    searchText: '',
    sortDirection: '',
    organizationUID: 'epicfarmshop',
  };

  componentWillMount() {
    const { currentUser, isConsumer, isPublic } = this.context;
    const { readShop } = this.props;
    const { organizationUID } = this.state;

    this.props.getPublicInfo({ organizationUID, isConsumer });
    const buyerId = currentUser.accountId;
    if (isPublic) {
      readShop(organizationUID);
    } else {
      readShop(organizationUID, { buyerId, onSuccess: this.onSuccessReadShop });
    }
  }

  onSuccessReadShop = () => {
    const { currentUser, isConsumer } = this.context;
    const { shop } = this.props;
    if (shop && shop.sellerProfile && isConsumer && currentUser.account.profile.firstName && currentUser.account.profile.lastName && !shop.buyerProfile) {
      const vendor = { email: shop.sellerProfile.email };
      this.addVendor(vendor);
    }
  }

  onCancelSearch = () => this.setState({ searchText: '' });

  onSearchText = value => this.setState({ searchText: value });

  onSortTimeStamp = () => {
    const { sortDirection } = this.state;
    const nextSortDirection = !sortDirection ? 'asc' : {
      asc: 'desc',
      desc: '',
    }[sortDirection];
    this.setState({ sortDirection: nextSortDirection });
  }

  extractOrganizationUID = (props) => {
    const { location } = props;
    return location.pathname.split('@')[1];
  }

  addVendor = (data) => {
    const { history, location } = this.props;
    this.props.createSeller({
      ...data,
      onSuccess: () => {
        history.push(location.pathname);
      },
    });
  }

  handleLogout = () => {
    memoryDB.tokenInfo = JSON.stringify({ data: {} });
    clearCartLocalStorage();
    window.location = '/';
  };

  handleAvatarClick = () => {
    const { history } = this.props;
    history.push('/settings');
  };

  render() {
    const { formatMessage, publicInfo, publicInfoRequesting, history,
      accessToken,
      permissions,
      location,
      shop,
      ...props } = this.props;
    const { searchText, organizationUID } = this.state;
    const { currentUser, isDistributor, isFarmer, currentMember } = this.context;
    if (!currentUser && window.location.pathname.includes('+')) {
      return <Redirect to={window.location.pathname.replace('+', 'shop@')} />
    }
    const isShopPage = true;
    // const { id, account: { email, profile: { companyName, logoUrl } } } = currentUser.organizations[0];
    const account = currentUser && currentUser.organizations && currentUser.organizations.length > 0 && currentUser.organizations[0].account;
    const email = account && account.email;
    const profile = account && account.profile;
    const companyName = profile && profile.companyName;
    const logoUrl = profile && profile.logoUrl;
    const clickable = true;

    let deactivated = false;
    if (accessToken && !currentMember && currentUser) {
      const {
        account: {
          profile: {
            firstName,
            lastName,
            mobile,
            companyName,
            addresses,
          },
        },
      } = currentUser || { account: { profile: { addresses: [{}] } } };
      const { address, city, state, zipcode } = addresses && addresses.length ? addresses[0] : {};

      if (!firstName || !lastName || !mobile || !companyName
        || !address || !city || !state || !zipcode) {
        if (get(currentUser, 'account.currentRoleId')) {
          deactivated = true;
        }
      }
    }

    // set nav-bar items for each mode.
    let filterOption = 'inBuyer';
    if (isFarmer) {
      filterOption = 'inSeller';
    } else if (isDistributor) {
      filterOption = 'inDistributor';
    }
    let items = permissions.filter(permission => permission[filterOption]);
    if (currentMember && currentMember.permissions) {
      items = items.filter(permission =>
        permission.isDivider || currentMember.permissions.find(({ id }) => permission.id === id),
      );
      items = items.filter((permission, index) =>
        !(permission.isDivider && (index === 0 || items[index - 1].isDivider)),
      );
    }
    if (!currentUser.role) {
      items = [];
    }
    items = items.map(permission => (
      permission.isDivider
        ? { divider: true }
        : {
          name: formatMessage(permission.name),
          url: `/${permission.frontendUrl}`,
        }
    ));
    items.push({ space: true });
    items.push({ divider: true });
    items.push(
      {
        handleClick: this.handleLogout,
        icon: 'fa fa-sign-out',
        name: formatMessage('Logout'),
      },
    );
    if (!publicInfo.account && !publicInfoRequesting) {
      return (
        <Fragment>
          <UnauthorizedHeader headerTitle={formatMessage('Not found')} />
          <Card
            style={{
              height: '100vh',
              overflowY: 'auto',
              paddingBottom: 100,
            }}
          />
        </Fragment>
      );
    }

    const avatarCurrentUser = (
      <div>
        {(email || companyName) && (
          <Avatar
            highlighted
            clickable={clickable}
            src={logoUrl}
            key={email}
            fullName={companyName || email}
            onClick={() => this.handleAvatarClick()}
          />
        )}
      </div>
    );

    return (
      <Fragment>
        <SearchComponent
          cancelSearch={this.onCancelSearch}
          placeholder={formatMessage('Items')}
          search={debounce(this.onSearchText, 500)}
          searchText={searchText}
        />
        <UnauthorizedHeader
          headerTitle={(
            <Fragment>
              <div className="d-md-down-none">
                {/* <b>{formatMessage('RETAIL SHOP')}</b>{' - '} */}
                <span style={{ fontSize: 14, verticalAlign: 'middle' }}>
                  {publicInfoRequesting
                    ? formatMessage('Loading ...')
                    : get(publicInfo, 'account.profile.companyName') || ''
                  }
                </span>
              </div>
            </Fragment>
          )}
          avatar={avatarCurrentUser}
          accessToken={accessToken}
          history={history}
          location={location}
          isShopPage={isShopPage}
        />
        {accessToken && (
          <SidebarItems
            items={items}
          />
        )}
        {publicInfoRequesting ? (
          <div className="main-progress">
            <CircularProgress />
          </div>
        ) : (
          <Shop organizationUID={organizationUID} history={history} location={history.location} addVendor={this.addVendor} shop={shop} />
        )}
        {accessToken && (
          <Sidebar
            currentMember={currentMember}
            currentUser={currentUser}
            history={history}
            deactivated={deactivated}
            {...props}
          />
        )}
      </Fragment>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('marketPlace', 'publicInfo')(state),
  accessToken: accessTokenSelector(state),
  ...selectState('options', 'permissions')(state, 'permissions'),
  ...selectState('buyers', 'buyers')(state, 'buyers'),
  ...selectState('sellers', 'sellers')(state, 'sellers'),
  ...selectState('shop', 'shop')(state, 'shop'),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  getPublicInfo: payload => dispatch(getPublicInfo(payload)),
  ...dispatchRestMaker([
    [sellersActions, 'seller'],
    [shopActions, 'shop'],
  ])(dispatch),
});

export default compose(
  setDisplayName('PublicShop'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
  withTracker,
)(PublicShop);

